import { combineReducers } from '@reduxjs/toolkit';
import type { AnyAction, Reducer } from '@reduxjs/toolkit';

import auth from 'app/auth/store';
import fuse from './fuse';
import i18n from './i18nSlice';
import pharmacySelector from '../shared-components/store/pharmacySelectorSlice';
import marketingResources from '../shared-components/store/marketingResourcesSlice';
import header from '../shared-components/store/headerSlice';

type AsyncReducersMap = Record<string, Reducer>;

const staticReducers = {
  auth,
  fuse,
  i18n,
  pharmacySelector,
  marketingResources,
  header,
};

const createReducer = (asyncReducers: AsyncReducersMap = {}): Reducer => {
  const combinedReducer = combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });

  type CombinedState = ReturnType<typeof combinedReducer>;

  return (state: CombinedState | undefined, action: AnyAction): CombinedState => {
    // On logout, re-initialise every slice by re-running the combined reducer from a clean
    // state. logoutUser also calls clearSession(), which clears localStorage, so there is nothing
    // worth preserving here — a single reset point avoids per-slice userLoggedOut handlers.
    if (action.type === 'auth/user/userLoggedOut') {
      return combinedReducer(undefined, action);
    }

    return combinedReducer(state, action);
  };
};

export default createReducer;
